import React, { Component } from 'react';
import firebase from 'firebase';
import {
  Button,
  Grid,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Badge,
} from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import ModalTopic from './ModalTopic';
import Loading from '../../components/Loading';

type IProps = {
  room: string,
};

type IState = {
  items: Object,
  modal: Object,
  loading: boolean,
};

class Topics extends Component {
  constructor(props: IProps) {
    super(props);

    this.state = {
      items: {},
      modal: null,
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    this.setState(
      {
        loading: true,
      },
      () => {
        const { room } = this.props;

        firebase
          .database()
          .ref(`room/${room}/topics`)
          .on('value', snapshot => {
            this.setState({
              items: snapshot.val() || {},
              loading: false,
            });
          });
      },
    );
  }

  handleSave(item: Object) {
    const { room } = this.props;

    const key =
      item.key ||
      firebase
        .database()
        .ref()
        .child(`room/${room}/topics`)
        .push().key;

    const updates = {
      [`room/${room}/topics/${key}`]: {
        name: item.name,
        enabled: item.enabled,
        description: item.description,
      },
    };

    firebase
      .database()
      .ref()
      .update(updates);

    this.setState({
      modal: null,
    });

    notify.show(`Topics were updated!`, 'success', 3000);
  }

  handleRemove() {
    const { room } = this.props;
    const { modal } = this.state;

    if (modal.key) {
      firebase
        .database()
        .ref(`room/${room}/topics/${modal.key}`)
        .remove();
    }

    this.setState({
      modal: null,
    });

    notify.show(`Topic was removed!`, 'success', 3000);
  }

  handleSelect(key: string) {
    const { items } = this.state;
    this.setState({
      modal: { key, ...items[key] },
    });
  }

  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;

    const { items, modal } = this.state;

    return (
      <Grid>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <div style={{ float: 'right' }}>
              <Badge bsStyle='default'>
                {Object.keys(items).length} topics
              </Badge>
            </div>
            <Button
              bsStyle='success'
              onClick={e => this.setState({ modal: {} })}
            >
              Add Topic
            </Button>
          </Col>
        </Row>
        <ListGroup>
          {Object.keys(items).map(key => {
            const item = items[key];

            return (
              <ListGroupItem
                key={item.key}
                header={item.name}
                onClick={e => this.handleSelect(key)}
                className={
                  !item.enabled && 'list-group-item list-group-item-danger'
                }
              >
                {item.description}
              </ListGroupItem>
            );
          })}
        </ListGroup>
        {Object.keys(items).length === 0 && <p>No topics in your room</p>}

        <ModalTopic
          item={modal}
          onClose={() => this.setState({ modal: null })}
          onSave={this.handleSave.bind(this)}
          onRemove={this.handleRemove.bind(this)}
        />
      </Grid>
    );
  }
}

export default Topics;



// WEBPACK FOOTER //
// ./src/pages/Topics/index.js